import * as React from 'react';
import * as i18n from 'i18next';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { browserHistory } from 'react-router';
import { IUserShippingAddress } from 'models/user/shipping/usershippingaddress';
import { IUserShippingAddresses, IUserShippingAddressesAction } from 'models/user/shipping/usershippingaddresses';
import {
	getUserShippingAddresses,
	setDefaultShippingAddress,
	deleteShippingAddress,
} from 'modules/user/shipping/usershippingaddresses';
import { IStore } from 'redux/IStore';
import { getCountryCallingCodeDomainValues } from 'modules/domainvalues';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { ItemCardList } from 'components';
import { showModal, closeModal } from 'modules/modal';
import { IModalAction } from 'models/modal';
import { ManageUserWrapper, ErrorPage } from 'containers';
import { getUserProfile } from 'redux/modules/user/userprofile';
import { IUserProfile, IUserProfileAction } from 'models/user/userprofile';
import { BasicButtonGrey } from 'components/Common/Button';
const { connect } = require('react-redux');

interface IProps {
	userValues: IUserProfile;
	userShippingAddresses?: IUserShippingAddresses;

	/* functions props */
	t?: (key: string) => string;
	getUserProfile: () => IUserProfileAction;
	getUserShippingAddresses?: () => IUserShippingAddressesAction;
	setDefaultShippingAddress?: (addressId: string) => IUserShippingAddressesAction;
	deleteShippingAddress?: (addressId: string) => IUserShippingAddressesAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
}

interface IShippingAddressesItemCardList extends IItemCardList {
	setDefaultUserShippingAddress?: (addressId: string) => void;
	isSingleAddress?: boolean;
}

@connect(
	(state: IStore) => ({
		userShippingAddresses: state.userShippingAddresses,
		userValues: state.userprofile.user,
	}),
	(dispatch) => ({
		getUserShippingAddresses: () => dispatch(getUserShippingAddresses()),
		setDefaultShippingAddress: (addressId: string) => dispatch(setDefaultShippingAddress(addressId)),
		deleteShippingAddress: (addressId: string) => dispatch(deleteShippingAddress(addressId)),
		getCountryCallingCodeDomainValues: () => dispatch(getCountryCallingCodeDomainValues()),
		getUserProfile: () => dispatch(getUserProfile()),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserShippingAddresses extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteShippingAddress = this.deleteShippingAddress.bind(this);
		this.openDeleteShippingAddress = this.openDeleteShippingAddress.bind(this);
	}

	public componentDidMount() {
		this.props.getUserProfile();
		this.props.getUserShippingAddresses();
	}

	public editItem(itemId: string) {
		browserHistory.push(`/user/edit/shippingaddresses/${itemId}/edit`);
	}

	private openDeleteShippingAddress(_, itemId: string) {
		const dialogContent = <p className="p14">{i18n.t('User_Shipping_ShippingAddresses_AboutDelete')}</p>;

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deleteShippingAddress,
			value: itemId,
			yesButtonText: i18n.t('User_Shipping_ShippingAddresses_Remove'),
			noButtonText: i18n.t('BSPortal_Common_Cancel'),
			content: dialogContent,
			title: i18n.t('BSPortal_Common_ConfirmationDialog_Sure'),
			closeModal: this.props.closeModal,
		});
	}

	private deleteShippingAddress(confirm: boolean, itemId: string) {
		if (confirm) {
			this.props.deleteShippingAddress(itemId);
		}
		this.props.closeModal();
	}

	public render() {
		if (this.props.userShippingAddresses.error) {
			return <ErrorPage {...this.props} message={this.props.userShippingAddresses.message} />;
		}

		const { t, userShippingAddresses, userValues } = this.props;

		let shippingAddresses: IUserShippingAddress[] = [];
		if (userShippingAddresses && userShippingAddresses.items && userShippingAddresses.items.length > 0) {
			shippingAddresses = userShippingAddresses.items;
		}

		const listProps: IShippingAddressesItemCardList = {
			items: shippingAddresses,
			itemType: c.NODE_TYPE_USER_SHIPPING_ADDRESS_CARD,
			isInfiniteScroll: false,
			setDefaultUserShippingAddress: this.props.setDefaultShippingAddress,
			isSingleAddress: Boolean(shippingAddresses.length === 1),
			editItem: this.editItem,
			deleteItem: this.openDeleteShippingAddress,
			noResults: <div className="errorMessage">{t('User_Shipping_ShippingAddresses_Message_NoShippingAddresses')}</div>,
		};

		const addAddressBtn = (
			<BasicButtonGrey
				onClick={() => {
					browserHistory.push('/user/edit/shippingaddresses/create');
				}}
			>
				{t('User_Shipping_ShippingAddresses_Button_AddAddress')}
			</BasicButtonGrey>
		);

		return (
			<div className="shippingAddresWrapper">
				<ManageUserWrapper user={userValues}>
					<br />
					<div className="shippingAddrescontentCards">
						<ItemCardList {...listProps} />
						{userShippingAddresses && userShippingAddresses.items && userShippingAddresses.items.length === 0 ? (
							<div className="noAddressContainer d-flex flex-column justify-content-center align-items-center">
								<p>{t('User_Shipping_ShippingAddresses_Message_NoShippingAddresses')}</p>
								{addAddressBtn}
							</div>
						) : (
							addAddressBtn
						)}
					</div>
				</ManageUserWrapper>
			</div>
		);
	}
}

export { UserShippingAddresses };
